<template>
    <v-container>
        <h3 style="font-size: 2em;">{{ TranslateText("Send Email")}}</h3>
        <br>
        <v-layout>
            <v-flex xs2 sm4 md4 lg4 xl4 ma-3>
                <v-select label="Email Type" v-model="form.Type" :items="items" v-on:input="checkSelected"></v-select>
            </v-flex>
        </v-layout>
        <v-flex v-if="welcomeEmail == true">
            <v-container>
                <v-card>
                    welcome test
                </v-card>
            </v-container>
        </v-flex>
        <v-flex v-if="emailConfirmation == true">
            <v-container>
                <v-card>
                    email confirmation test
                </v-card>
            </v-container>
        </v-flex>
        <v-flex v-if="passwordReset == true">
            <v-container>
                <v-card>
                    password reset test
                </v-card>
            </v-container>
        </v-flex>
        <v-flex v-if="newsLetter == true">
            <v-container>
                <v-card>
                    newsletter test
                </v-card>
            </v-container>
        </v-flex>
        <v-flex v-if="invoice == true">
            <v-container>
                <v-card>
                    invoice test
                </v-card>
            </v-container>
        </v-flex>
        <!-- <v-card class="elevation-20">
            <v-divider></v-divider>
            <v-layout wrap>
                <v-flex xs2>
                    <v-text-field label="To" v-model="form.SendTo" single-line full-width hide-details @keyup.enter="addUserToSendList"></v-text-field>
                </v-flex>
                <v-flex xs10 class="text-xs-right">
                    <v-chip>
                        {{ form.ToSendList }}
                    </v-chip>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs2>
                    <v-text-field label="CC" v-model="form.CCTo" single-line full-width hide-details @keyup.enter="addUserToCCList"></v-text-field>
                </v-flex>
                <v-flex xs10 class="text-xs-right">
                    <v-chip>
                        {{ form.ToCCList }}
                    </v-chip>
                </v-flex>
                <v-flex xs12>
                    <v-divider></v-divider>
                    <v-text-field label="Subject" v-model="form.Subject" single-line full-width hide-details></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-divider></v-divider>
                    <v-textarea label="Message" v-model="form.Message" counter max="120" height="250px" full-width
                        multi-line single-line></v-textarea>
                </v-flex>
                <v-flex>
                    <v-layout justify-end>
                        <v-btn icon>
                            <v-icon color="primary" @click="sendEmail">send</v-icon>
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card> -->
    </v-container>
</template>


<script>
    export default {
        data() {
            return {
                form: {
                    Type: 'Welcome Email',
                    SendTo: null,
                    CCTo: null,
                    ToSendList: [],
                    ToCCList: [],
                    Subject: null,
                    Message: null,
                },
                items: ["Welcome Email", "Email Confirmation", "Password Reset", "News Letter", "Invoice"],
                welcomeEmail: false,
                emailConfirmation: false,
                passwordReset: false,
                newsLetter: false,
                invoice: false,
                item: null
            }

        },
        mounted() {
            let self = this;

        },
        methods: {
            checkSelected() {
                let self = this;

                if (self.form.Type == "Welcome Email") {
                    self.welcomeEmail = true;
                    self.emailConfirmation = false;
                    self.passwordReset = false;
                    self.newsLetter = false;
                    self.invoice = false;
                } else if (self.form.Type == "Email Confirmation") {
                    self.welcomeEmail = false;
                    self.emailConfirmation = true;
                    self.passwordReset = false;
                    self.newsLetter = false;
                    self.invoice = false;
                } else if (self.form.Type == "Password Reset") {
                    self.welcomeEmail = false;
                    self.emailConfirmation = false;
                    self.passwordReset = true;
                    self.newsLetter = false;
                    self.invoice = false;
                } else if (self.form.Type == "News Letter") {
                    self.welcomeEmail = false;
                    self.emailConfirmation = false;
                    self.passwordReset = false;
                    self.newsLetter = true;
                    self.invoice = false;
                } else if (self.form.Type == "Invoice") {
                    self.welcomeEmail = false;
                    self.emailConfirmation = false;
                    self.passwordReset = false;
                    self.newsLetter = false;
                    self.invoice = true;
                }
                console.log(self.form.Type)
            },
            fetchData() {
                let self = this;


            },
            sendEmail() {
                let self = this;
                var Request = self.form;

                // TODO actual send email logic
                console.log(Request);
                self.form = "";
            },
            addUserToSendList() {
                let self = this;

                self.form.ToSendList.push(self.form.SendTo);
                self.form.SendTo = "";
            },
            addUserToCCList() {
                let self = this;

                self.form.ToCCList.push(self.form.CCTo);
                self.form.CCTo = "";
            }
        }
    }
</script>

<style>

</style>